import * as React from "react";
import classes from "./AuditTrail.module.css";
import Grid from "@mui/material/Grid";
import Autocomplete from "@mui/material/Autocomplete";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TextField from "@mui/material/TextField";
import AuditTrailSearchResults from "../AuditTrailSearchResult/AuditTrailSearchResult";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
} from "components/AccordionComponents/AccordionComponents";
import {
  getAllSystems,
  getAllHRSystems,
  getAllSubSystemsBySystemID,
  getEmployeeSystemTransactionLogs,
  getEmployeeNameFromAuditLogs,
} from "services/centerPointUserServices";
import Checkbox from "@mui/material/Checkbox";
import BackdropComponent from "components/Spinner/Spinner";
import SnackBar from "components/SnackBar/SnackBar";
import InputAdornment from "@mui/material/InputAdornment";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ClearIcon from "@mui/icons-material/Clear";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import moment from "moment";
import { debounce } from "utils/debounce";
import applicationUsageLog from "../../../utils/applicationUsagesLog";
import { CustomButton } from "components/RosterConfig/RosterConfigStyle";
import { Typography } from "@mui/material";
const typographyStyle = {
  fontFamily: "Urbanist, Verdana, Arial, sans-serif",
  letterSpacing: "0.10rem",
  fontWeight: "bold",
  color: "#3F5765",
  marginTop: 1,
};
const AuditTrail = () => {
  const [expandedPanel1, setExpandedPanel1] = React.useState(true);
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState("");
  const [loader, setLoader] = React.useState(false);
  const [employeeId, setEmployeeId] = React.useState("");
  const [name, setName] = React.useState("");
  const [loginId, setLoginId] = React.useState("");
  const [earliestTransaction, setEarliestTransaction] = React.useState("");
  const [latestTransaction, setLatestTransaction] = React.useState("");
  const [includeBulkTransaction, setIncludeBulkTransaction] =
    React.useState(false);
  const [subSystemArray, setSubSystemArray] = React.useState([]);
  const [systemsArray, setSystemsArray] = React.useState([]);
  const [hrSystem, setHrSystem] = React.useState({
    Name: "TTEC HRMS",
    CP_HRSystemId: "",
  });
  const [hrSystemArray, setHrSystemArray] = React.useState([]);
  const [system, setSystem] = React.useState({
    Code: "",
    Name: "",
  });
  const [subSystem, setSubSystem] = React.useState({
    CP_SubSystemId: "",
    SubSystemName: "",
  });
  const [snack, setSnack] = React.useState({
    open: false,
    message: "",
    severity: "",
  });
  const [dropDownLoading, setDropDownLoading] = React.useState(false);
  const [dropDownState, setDropDownState] = React.useState(false);
  const [employeeNamesArray, setEmployeeNamesArray] = React.useState([]);
  const [initialEmployeeNamesArray, setInitialEmployeeNamesArray] =
    React.useState([]);
  const [rows, setRows] = React.useState([]);
  const [dropDownMessage, setDropDownMessage] = React.useState(
    "Please enter atleast 3 characters to start searching !",
  );
  const [searchValue, setSearchValue] = React.useState([]);

  const inputRef = React.useRef(null);

  const handleMenuClick = (e, rowItem) => {
    setName(() => rowItem?.EmployeeName);
    setDropDownState(false);
    inputRef.current.blur();
  };

  const snackReset = () => {
    setSnack({
      open: false,
      message: "",
      severity: "",
    });
  };

  React.useEffect(() => {
    let cancelled = false;

    const initialize = async () => {
      try {
        await fetchData();

        if (!cancelled) {
          applicationUsageLog(
            localStorage.getItem("User"),
            localStorage.getItem("EmailId"),
            "CenterPoint",
            "Audit Trail",
          );
        }
      } catch (error) {
        if (!cancelled) {
          console.error("Failed to initialize:", error);
        }
      }
    };

    initialize();

    return () => {
      cancelled = true;
    };
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      const response = await getAllSystems();
      if (response?.data?.message === "Success") {
        setSystemsArray(response?.data?.data);
      } else errorHandler(true, "Systems could not be fetched.", "error");

      const hrSystemResponse = await getAllHRSystems();
      if (hrSystemResponse?.data?.message === "Success") {
        setHrSystemArray([
          { Name: "TTEC HRMS", CP_HRSystemId: "" },
          ...(hrSystemResponse?.data?.data || []),
        ]);
      } else {
        errorHandler(true, "HR Systems could not be fetched.", "error");
      }
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }

    setLoader(false);
  };

  const handleSystemChange = async (value) => {
    setLoader(true);
    try {
      const response = await getAllSubSystemsBySystemID(value?.CP_SystemId);
      if (response?.data?.message === "Success") {
        setSubSystemArray(response?.data?.data);
      } else errorHandler(true, "Sub Systems could not be fetched.", "error");
    } catch (error) {
      errorHandler(true, "Some internal error occured.", "error");
    }

    setLoader(false);
  };

  const errorHandler = (open, message, severity) => {
    setSnack({
      open: open,
      message: message,
      severity: severity,
    });
  };

  const debouncedHandleEmployeeDetails = React.useCallback(
    debounce(async (searchValue) => {
      setEmployeeNamesArray([]);
      if (searchValue.length >= 3) {
        setDropDownLoading(true);
        const response = await getEmployeeNameFromAuditLogs(searchValue);
        if (response?.data?.message === "Success") {
          setEmployeeNamesArray(response?.data?.data);
          setInitialEmployeeNamesArray(response?.data?.data);
          setDropDownLoading(false);
        } else {
          setEmployeeNamesArray([]);
          setDropDownLoading(false);
          setDropDownMessage("No records found !");
          errorHandler(true, "Could not fetch search type results", "error");
        }
      } else {
        setDropDownLoading(false);
      }
    }, 500),
    [],
  );

  function getEmployeeNames(inputValue) {
    debouncedHandleEmployeeDetails(inputValue);
  }

  const handleSearch = async () => {
    setLoader(true);
    const payload = {
      hrSystem: hrSystem?.Name,
      employeeId: employeeId ? Number(employeeId) : 0,
      employeeName: name,
      logonId: loginId,
      systemId: system?.CP_SystemId ? system?.CP_SystemId : 0,
      subSystemId: subSystem?.CP_SubSystemId ? subSystem?.CP_SubSystemId : 0,
      updatedDateTimeEarliest: earliestTransaction,
      updatedDateTimeLatest: latestTransaction,
      isBulk: includeBulkTransaction,
    };
    if (
      !hrSystem &&
      !employeeId &&
      !name &&
      !loginId &&
      !system?.CP_SystemId &&
      !subSystem?.CP_SubSystemId &&
      !earliestTransaction &&
      !latestTransaction
    ) {
      setError(true);
      setErrorMessage(" Please select atleast one filter to continue");
    } else if (employeeId && !/^\d+$/.test(employeeId)) {
      setError(true);
      setErrorMessage("Please enter only numeric values in Employee id");
    } else {
      setError(false);
      try {
        const response = await getEmployeeSystemTransactionLogs(payload);
        if (response?.data?.message === "Success") {
          setRows(response?.data?.data);
        } else {
          setRows([]);
          setLoader(false);
          errorHandler(true, "No results found.", "info");
        }
      } catch (error) {
        errorHandler(true, "Something went wrong", "error");
      }
    }

    setLoader(false);
  };

  const handleReset = () => {
    setEmployeeId("");
    setName("");
    setSearchValue("");
    setLoginId("");
    setEarliestTransaction("");
    setLatestTransaction("");
    setIncludeBulkTransaction(false);
    setSystem({
      Code: "",
      Name: "",
    });
    setSubSystemArray([]);
    setSubSystem({
      CP_SubSystemId: "",
      SubSystemName: "",
    });
    setHrSystem({
      Name: "TTEC HRMS",
      CP_HRSystemId: "",
    });
    setRows([]);
    setEmployeeNamesArray([]);
  };
  return (
    <>
      {loader ? <BackdropComponent /> : null}
      <Accordion
        expanded={expandedPanel1}
        onChange={() => setExpandedPanel1((prev) => !prev)}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <div className={classes.headingContainer}>
            <p className={classes.filterText}> Audit Trails</p>
          </div>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>HR System</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <Autocomplete
                disablePortal
                blurOnSelect
                options={hrSystemArray}
                value={hrSystem}
                className={classes.searchField}
                onChange={(e, value) => setHrSystem(value)}
                getOptionLabel={(option) =>
                  option?.CP_HRSystemId === ""
                    ? option?.Name
                    : `${option?.Name} (${option?.CP_HRSystemId})`
                }
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>Earliest Transaction</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <input
                type="date"
                className={classes.dateField}
                placeholder="MM/DD/YYYY"
                value={moment(earliestTransaction).format("YYYY-MM-DD")}
                onChange={(e) => {
                  setEarliestTransaction(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>
                Oracle Id / Ext EmployeeID
              </Typography>
            </Grid>
            <Grid item xs={4.5}>
              <TextField
                id="outlined-basic"
                variant="outlined"
                size="small"
                className={classes.searchField}
                multiline
                value={employeeId}
                onChange={(e) => setEmployeeId(e.target.value)}
                rows={1}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>Latest Transaction</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <input
                type="date"
                className={classes.dateField}
                placeholder="MM/DD/YYYY"
                value={moment(latestTransaction).format("YYYY-MM-DD")}
                onChange={(e) => {
                  setLatestTransaction(e.target.value);
                }}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>Name</Typography>
            </Grid>
            <Grid item xs={4.5} className={classes.autoCompleteGridAuditTrail}>
              <TextField
                id="outlined-start-adornment"
                size="small"
                value={name || searchValue}
                inputRef={inputRef}
                className={classes.dropDownInputAuditTrail}
                onFocus={() => setDropDownState(true)}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
                onBlur={() => setDropDownState(false)}
                onChange={(e) => {
                  const { value } = e.target;
                  setSearchValue(value);
                  const exists = initialEmployeeNamesArray?.some((item) =>
                    item.EmployeeName.toLowerCase().includes(
                      value.toLowerCase(),
                    ),
                  );
                  if (!exists) {
                    getEmployeeNames(value);
                  } else {
                    setEmployeeNamesArray(
                      initialEmployeeNamesArray?.filter((item) =>
                        item?.EmployeeName?.toLowerCase().includes(
                          value.toLowerCase(),
                        ),
                      ),
                    );
                  }
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="start">
                      <div className={classes.dropDownIconsAuditTrail}>
                        {dropDownState && (
                          <ClearIcon
                            onMouseDown={(e) => e.preventDefault()}
                            onClick={() => {
                              setSearchValue("");
                              setName("");
                              setDropDownLoading(false);
                            }}
                            className={classes.clearIconAuditTrail}
                          />
                        )}
                        {dropDownState ? (
                          <ArrowDropUpIcon />
                        ) : (
                          <ArrowDropDownIcon />
                        )}
                      </div>
                    </InputAdornment>
                  ),
                }}
              />

              {dropDownState && (
                <div className={classes.autoCompleteDiv}>
                  {!dropDownLoading && employeeNamesArray?.length === 0 && (
                    <p className={classes.dropDownMessageAuditTrail}>
                      {dropDownMessage}
                    </p>
                  )}
                  {!dropDownLoading &&
                    employeeNamesArray?.length > 0 &&
                    employeeNamesArray?.map((rowItem, index) => (
                      <button
                        key={rowItem?.EmployeeName}
                        className={classes.menuItemAuditTrail}
                        onMouseDown={(e) => e.preventDefault()}
                        onClick={(e) => handleMenuClick(e, rowItem)}
                      >
                        {rowItem?.EmployeeName ? rowItem?.EmployeeName : ""}
                      </button>
                    ))}
                  {dropDownLoading && (
                    <Box className={classes.dropdownLoaderAuditTrail}>
                      <CircularProgress className={classes.auditLoader} />
                    </Box>
                  )}
                </div>
              )}
            </Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={4.5}></Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>Logon ID</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <TextField
                id="outlined-basic"
                className={classes.searchField}
                size="small"
                variant="outlined"
                multiline
                value={loginId}
                onChange={(e) => setLoginId(e.target.value)}
                rows={1}
                onKeyDown={(e) => {
                  if (e.key === "Enter") e.preventDefault();
                }}
              />
            </Grid>
            <Grid item xs={1.8}>
              <Typography sx={{ ...typographyStyle, marginTop: 0 }}>
                Include Bulk Transaction ?
              </Typography>
            </Grid>
            <Grid item xs={4.2}>
              <Checkbox
                checked={includeBulkTransaction}
                onChange={(e) => setIncludeBulkTransaction(e.target.checked)}
              />
            </Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>System</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <Autocomplete
                disablePortal
                blurOnSelect
                options={systemsArray}
                value={system}
                className={classes.searchField}
                onChange={(e, value) => {
                  setSystem(value);
                  handleSystemChange(value);
                }}
                getOptionLabel={(option) =>
                  option?.Name === ""
                    ? ""
                    : `${option?.Name + " (" + option?.Code + ")"}`
                }
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={4.5}></Grid>
            <Grid item xs={1.5}>
              <Typography sx={typographyStyle}>Sub-System</Typography>
            </Grid>
            <Grid item xs={4.5}>
              <Autocomplete
                disablePortal
                blurOnSelect
                options={subSystemArray}
                value={subSystem}
                className={classes.searchField}
                onChange={(e, value) => setSubSystem(value)}
                getOptionLabel={(option) =>
                  option?.SubSystemName === ""
                    ? ""
                    : `${
                        option?.SubSystemName +
                        " (" +
                        option?.CP_SubSystemId +
                        ")"
                      }`
                }
                renderInput={(params) => <TextField {...params} size="small" />}
              />
            </Grid>
            <Grid item xs={1.5}></Grid>
            <Grid item xs={4.5}>
              {" "}
              <div className={classes.buttonContainer}>
                <CustomButton
                  variant="contained"
                  sx={{ backgroundColor: "#3299FF" }}
                  onClick={handleSearch}
                >
                  Search
                </CustomButton>
                <CustomButton
                  variant="outlined"
                  sx={{ color: "#3299FF" }}
                  onClick={handleReset}
                >
                  Reset
                </CustomButton>
              </div>
            </Grid>
          </Grid>
          {error && <p className={classes.error}>{errorMessage}</p>}
        </AccordionDetails>
      </Accordion>
      <hr />
      {rows?.length > 0 && <AuditTrailSearchResults rows={rows} />}
      <SnackBar snack={snack} snackReset={snackReset}></SnackBar>
    </>
  );
};

export default AuditTrail;
